<style>
    .field {
        padding: 5px;
    }

    textarea {
        width: 100%;
        height: 100px;
    }

    input {
        width: 250px;
        margin-top: 5px;
    }
</style>

<script>
    import { getContext } from 'svelte';
    const { close } = getContext('simple-modal');

    export let changePassword;
    let newPassword1 = "";
    let newPassword2 = "";
    let oldPassword = "";

    function submit() {
        if(newPassword1 != newPassword2) {
            alert("New Password is not the same in both text boxes.")
            return;
        }

        if(oldPassword.length == 0) {
            alert("Please enter your current password.")
            return;
        }

        if(newPassword1.length == 0) {
            alert("New password cannot be empty.")
            return;
        }

        changePassword(oldPassword, newPassword1)
        close();
    }
</script>

<h1>Changing Password</h1>
<p>
    Please try your best to choose a secure password that you will remember. A <a href="https://en.wikipedia.org/wiki/Password_manager">Password Manager</a> can help greatly with this.
</p>
<div class="field">
    <strong>Current Password</strong><br>
    <input type="password" bind:value={oldPassword}>
</div>
<div class="field">
    <strong>New Password</strong><br>
    <input type="password" bind:value={newPassword1}>
</div>
<div class="field">
    <strong>Confirm New Password</strong><br>
    <input type="password" bind:value={newPassword2}>
</div>
<div class="field">
    <button on:click={submit}>Submit</button>
</div>
